<template>
  <!-- 公用-top-(包含用户登录，找回密码) -->
  <div class="">
    <!--登录-top  -->
    <div class="common-topbox" v-if="$store.state.loginShow">
      <span class="topbox-htoptle">包头市知识产权智慧监管公共服务平台</span>
      <!-- 已登录-显示的内容 -->
      <div class="topbox-htoploginuser">
        <div class="htopmenu-userinfo">
          <el-dropdown v-if="$store.state.userRole == 3">
            <span class="el-dropdown-link userinfo-userres"> 控制面板<i class="iconfont icon-sanjiaodown"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/adminUser/userTable"> <el-dropdown-item>用户管理</el-dropdown-item></router-link>
              <router-link to="/adminIntegral/integralTable">
                <el-dropdown-item>积分管理</el-dropdown-item>
              </router-link>
              <router-link to="/adminServe/serveTable">
                <el-dropdown-item>服务管理</el-dropdown-item>
              </router-link>
              <router-link to="/adminServe/serveTort">
                <el-dropdown-item>侵权管理</el-dropdown-item>
              </router-link>
              <!-- <el-dropdown-item>新闻政策管理</el-dropdown-item>
              <el-dropdown-item>操作日志</el-dropdown-item>
              <el-dropdown-item>访问统计</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 用户-个人中心 -->
          <el-dropdown @command="handleUserCommand">
            <span class="el-dropdown-link userinfo-userres">
              {{ $store.state.userHead }}<i class="iconfont icon-sanjiaodown"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">用户信息</el-dropdown-item>
              <el-dropdown-item command="b">我的积分</el-dropdown-item>
              <el-dropdown-item command="c">我的服务</el-dropdown-item>
              <el-dropdown-item command="d">修改密码</el-dropdown-item>
              <el-dropdown-item command="e"
                >退出登录
                <!-- <div calss="" @click="logoutHandleClick">退出登录</div> -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span class="htopmenu-msgnum" @click="goNews">
          消息通知
          <span class="msgnum-style" v-show="$store.state.unRead > 0">{{
            $store.state.unRead > 99 ? '99+' : $store.state.unRead
          }}</span>
        </span>
        <!-- <span class="htopmenu-msgnum">消息通知<span class="msgnum-style">99+</span></span> -->
      </div>
    </div>
    <!-- 未登录-top -->
    <div class="common-topbox" v-else>
      <span class="topbox-htoptle">包头市知识产权智慧监管公共服务平台</span>
      <ul class="topbox-htopmenu">
        <li class="htopmenu-htopli">
          <span class="htopli-htopa htopli-htoplogin" data-logtype="立即登录" @click="loginHandleClick($event)"
            >立即登录</span
          >
          <i class="htopli-htopi"></i>
        </li>
        <li class="htopmenu-htopli">
          <router-link class="htopli-htopa" to="/register" target="_blank">免费注册</router-link>
        </li>
        <li class="htopmenu-htopli">
          <span class="htopli-htopa" data-logtype="企业入口" @click="loginHandleClick($event)">企业入口</span>
        </li>
        <li class="htopmenu-htopli">
          <span class="htopli-htopa" data-logtype="管理员入口" @click="loginHandleClick($event)">管理员入口</span>
        </li>
      </ul>
    </div>

    <!-- 登录-弹框 -->
    <el-dialog custom-class="popup-loginpop" :visible.sync="loginVisibleShow" :close-on-click-modal="true">
      <!-- 登录-部分-显示/隐藏 -->
      <div v-show="loginPopupShow">
        <!-- tab切换  密码登录/验证码登录 -->
        <el-tabs class="loginpop-logintabs" v-model="loginType" type="card" @tab-click="getActiveIdx">
          <!-- 密码登录 ------------------------------------------------------------------------------------------------------- -->
          <el-tab-pane label="密码登录">
            <div class="login-box login-pwdbox">
              <div class="login-logform">
                <el-input
                  class="logform-loginput"
                  type="text"
                  v-model="loginPwdPhone"
                  @blur="phoneChangeBlur(loginPwdPhone)"
                  placeholder="手机号"
                >
                </el-input>
                <span class="logform-loghint logform-logerror">{{ phoneHint }}</span>
              </div>
              <div class="login-logform">
                <el-input
                  class="logform-loginput"
                  type="password"
                  v-model="loginPassword"
                  @blur="pwdPasswordLoginChangeBlur"
                  placeholder="密码"
                >
                </el-input>
                <span class="logform-loghint logform-logerror">{{ pwdHint }}</span>
                <!-- <el-button class="logform-logforgetbtn" type="text" @click="forgetPwdHandleClick">忘记密码</el-button> -->
              </div>
              <!-- <div>
                <span class="logform-loghint logform-gracodehint logform-logerror">{{imgCodeHint}}</span>
              </div> -->
              <!--图形验证码-->
              <div class="login-logform login-loggraphcode">
                <div class="loggraphcode-gracodebox">
                  <el-input
                    class="loggraphcode-graphinput"
                    type="text"
                    v-model="loginGraphCode"
                    @blur="imgCodeChangeBlur"
                    @keyup.enter.native="loginSubmit"
                    placeholder="验证码"
                  >
                  </el-input>
                  <img class="loggraphcode-graphimg" @click="codeImgChange" :src="imgCodeUrl" />
                </div>
                <span class="logform-loghint logform-gracodehint logform-logerror">{{ imgCodeHint }}</span>
                <el-button class="logform-logforgetbtn" type="text" @click="forgetPwdHandleClick">忘记密码</el-button>
              </div>
            </div>
          </el-tab-pane>
          <!-- 验证码登录 ------------------------------------------------------------------------------------------------------- -->
          <el-tab-pane label="验证码登录">
            <div class="login-box login-codebox">
              <div class="login-logform">
                <el-input
                  class="logform-loginput"
                  type="text"
                  v-model="loginCodePhone"
                  @blur="phoneChangeBlur(loginCodePhone)"
                  @keyup.enter.native="getLoginCodeClick"
                  placeholder="手机号"
                >
                </el-input>
                <span class="logform-loghint logform-logerror">{{ phoneHint }}</span>
              </div>
              <div class="login-logform login-logverificate">
                <el-input
                  class="logform-loginput logverificate-loginput"
                  type="text"
                  v-model="loginVeriCode"
                  @blur="veriCodeChangeBlur"
                  placeholder="验证码"
                  ref="codeInp"
                  @keyup.enter.native="loginSubmit"
                >
                </el-input>
                <el-button class="logform-logveribtn" type="text" v-show="countDownShow" @click="getLoginCodeClick">
                  获取验证码
                </el-button>
                <el-button
                  class="logform-logveribtn logform-logveribtn-active"
                  v-show="!countDownShow"
                  type="info"
                  disabled
                >
                  重新发送{{ loginCountDown }}s
                </el-button>
                <span class="logform-loghint logform-logerror">{{ veriCodeHint }}</span>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-button class="loginpop-loginbtn" type="primary" v-show="clickWay" @click="loginSubmit"
          >管理员登录</el-button
        >
        <el-button class="loginpop-loginbtn" type="primary" v-show="!clickWay" @click="loginSubmit">登录</el-button>
        <router-link
          class="loginpop-goregister"
          to="/register"
          v-show="!clickWay"
          @click.native="loginVisibleShow = false"
          >免费注册</router-link
        >
      </div>
      <!-- 忘记密码-找回密码-部分-显示/隐藏 -------------------------------------------------------------------------------------- -->
      <div v-show="findPwdPopupShow">
        <div class="findpwdpop-findtitle">找回密码</div>
        <div class="login-box login-pwdbox">
          <div class="login-logform">
            <el-input
              class="logform-loginput"
              type="text"
              v-model="findPhone"
              @blur="phoneChangeBlur(findPhone)"
              placeholder="手机号"
            >
            </el-input>
            <span class="logform-loghint logform-logerror">{{ phoneHint }}</span>
          </div>
          <div class="login-logform findpwd-fverificate">
            <el-input
              class="logform-loginput logverificate-loginput"
              type="text"
              v-model="findVeriCode"
              @blur="findVeriChangeBlur"
              placeholder="验证码"
            >
            </el-input>
            <el-button class="logform-logveribtn" type="text" v-show="countDownFindShow" @click="getFindCodeClick">
              获取验证码
            </el-button>
            <el-button
              class="logform-logveribtn logform-logveribtn-active"
              v-show="!countDownFindShow"
              type="info"
              disabled
            >
              重新发送{{ findCountDown }}s
            </el-button>
            <span class="logform-loghint logform-logerror">{{ findVeriHint }}</span>
          </div>
          <div class="login-logform">
            <el-input
              class="logform-loginput"
              type="password"
              v-model="findPwd"
              @blur="pwdChangeBlur(findPwd)"
              placeholder="密码"
            >
            </el-input>
            <span
              :class="['logform-loghint', pwdFindHint == '8-16字符，至少同时包含字母和数字' ? '' : 'logform-logerror']"
            >
              {{ pwdFindHint }}
            </span>
          </div>
          <div class="login-logform findpwd-repeatmb">
            <el-input
              class="logform-loginput"
              type="password"
              v-model="findRepeatPwd"
              @blur="pwdRepeatChangeBlur"
              placeholder="确认密码"
            >
            </el-input>
            <span class="logform-loghint logform-logerror">{{ pwdRepeatHint }}</span>
          </div>
        </div>
        <el-button class="loginpop-loginbtn" type="primary" @click="ForgetSubmit">找回密码并登录</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog custom-class="popup-loginpop" :visible.sync="upPwdPopupShow" :close-on-click-modal="true">
      <div>
        <div class="findpwdpop-findtitle">修改密码</div>
        <div class="login-box login-pwdbox">
          <div class="login-logform">
            <el-input
              class="logform-loginput"
              type="text"
              v-model="upPhone"
              @blur="phoneChangeBlur(upPhone)"
              placeholder="手机号"
            ></el-input>
            <span class="logform-loghint logform-logerror">{{ phoneHint }}</span>
          </div>
          <div class="login-logform" v-show="upOldPassShow">
            <el-input
              class="logform-loginput"
              type="password"
              v-model="upOldPass"
              @blur="upOldPassChangeBlur(upOldPass)"
              placeholder="旧密码"
            ></el-input>
            <span class="logform-loghint logform-logerror">
              {{ oldPwdFindHint }}
            </span>
            <el-button class="logform-logforgetbtn" style="margin-top: -1px" type="text" @click="upShowCode"
              >忘记旧密码</el-button
            >
          </div>
          <div class="login-logform findpwd-fverificate" v-show="upPassCodeShow">
            <el-input
              class="logform-loginput logverificate-loginput"
              type="text"
              v-model="upCode"
              @blur="upFindVeriChangeBlur"
              placeholder="验证码"
            ></el-input>
            <el-button class="logform-logveribtn" type="text" v-show="countDownFindShow" @click="upCodeClick"
              >获取验证码
            </el-button>
            <el-button
              class="logform-logveribtn logform-logveribtn-active"
              v-show="!countDownFindShow"
              type="info"
              disabled
              >重新发送{{ findCountDown }}s</el-button
            >
            <span class="logform-loghint logform-logerror">{{ findVeriHint }}</span>
          </div>
          <div class="login-logform">
            <el-input
              class="logform-loginput"
              type="password"
              v-model="upNewPass"
              @blur="pwdChangeBlur(upNewPass)"
              placeholder="密码"
            ></el-input>
            <span
              :class="['logform-loghint', pwdFindHint == '8-16字符，至少同时包含字母和数字' ? '' : 'logform-logerror']"
            >
              {{ pwdFindHint }}
            </span>
          </div>
          <div class="login-logform findpwd-repeatmb">
            <el-input
              class="logform-loginput"
              type="password"
              v-model="upQpass"
              @blur="upPwdRepeatChangeBlur"
              placeholder="确认密码"
            ></el-input>
            <span class="logform-loghint logform-logerror">{{ pwdRepeatHint }}</span>
          </div>
        </div>
        <el-button class="loginpop-loginbtn" type="primary" @click="upForgetSubmit">确认修改</el-button>
        <el-button class="loginpop-loginbtn" style="background: #fff; color: #d42a2a" @click="upPwdPopupShow = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <!-- 退出登录 -->
    <el-dialog custom-class="popup-loginpop" :visible.sync="popLoginShow" :close-on-click-modal="true">
      <div>
        <div class="findpwdpop-findtitle">退出登录？</div>
        <el-button style="margin-top: 30px" class="loginpop-loginbtn" type="primary" @click="popLogin">退出</el-button>
        <el-button class="loginpop-loginbtn" style="background: #fff; color: #d42a2a" @click="popLoginShow = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 权限不足弹窗 -->
    <el-dialog title="" :visible.sync="powerDialogShow" width="500px">
      <span class="viewpop-viewtitle">权限不足</span>
      <div class="dialog-info">
        <p>只有审核通过的本地机构用户才能享受本项增值服务。</p>
        <p>若您是包头市本地机构，请点击下方按钮填写信息，并提交审核。</p>
      </div>
      <div class="viewpop-viewbtn">
        <router-link to="/user/info">
          <el-button class="viewbtn-btnstyle viewbtn-replybtn viewbtn-replybtn-active" type="primary">去填写</el-button>
        </router-link>
        <el-button class="viewbtn-btnstyle viewbtn-delbtn" type="primary" @click="powerDialogShow = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userMessage: '', // 用户信息
      topLoginShow: false, // 判断登录top显示/隐藏
      clickWay: false, // 判断点击的是哪个--立即登录/企业登录/管理员登录
      loginVisibleShow: false, // 登录/忘记密码-弹框显示/隐藏
      // 登录
      loginPopupShow: true, // 登录部分内容-显示
      loginPwdPhone: '', // 密码登录-手机号
      loginPassword: '', // 密码登录-密码
      loginGraphCode: '', // 密码登录-图形验证码
      imgCodeUrl: '', // 图形验证码-链接图片
      loginCodePhone: '', // 验证码登录-手机号
      loginVeriCode: '', // 验证码登录-短信验证码
      loginType: '0', // 判断登录方式--密码登录-0/验证码登录-1
      phoneHint: '', // 登录/找回密码-手机号-提示
      pwdHint: '', // 登录-密码-提示
      imgCodeHint: '', // 登录-图形验证码-提示
      veriCodeHint: '', // 登录-短信验证码-提示
      // 忘记-找回密码
      findPwdPopupShow: false, // 找回密码部分内容-显示
      findPhone: '', // 密码-手机号
      findVeriCode: '', // 找回密码-短信验证码
      findPwd: '', // 找回密码-密码
      findRepeatPwd: '', // 找回密码-确认密码
      findVeriHint: '', // 找回密码-短信验证码-提示
      pwdFindHint: '', // 找回密码-密码-提示
      pwdRepeatHint: '', // 找回密码-确认密码-提示
      // 验证码登录-获取验证码
      setTimer: '', // 倒计时-setInterval
      phoneLoginTrue: true, // 判断输入的手机号是否已注册，已注册的话才倒计时
      loginCountDown: 0, // 倒计时-120s
      countDownShow: true, // 显示获取验证码的按钮
      // 找回密码-获取验证码
      setFindTimer: '', // 倒计时-setInterval
      phoneFindTrue: true, // 判断输入的手机号是否已注册，已注册的话才倒计时
      findCountDown: 0, // 倒计时-120s
      countDownFindShow: true, // 显示获取验证码的按钮
      totalCount: '', // 消息数量
      // 修改密码弹框
      upPwdPopupShow: false,
      // 是否展示修改密码验证码
      upPassCodeShow: false,
      // 是否展示输入旧密码
      upOldPassShow: true,
      // 修改密码-手机号
      upPhone: '',
      // 修改密码-旧密码
      upOldPass: '',
      // 旧密码修改提示
      oldPwdFindHint: '',
      // 修改密码-验证码
      upCode: '',
      // 修改密码-新密码
      upNewPass: '',
      // 修改密码-确认新密码
      upQpass: '',
      // 退出登录弹框
      popLoginShow: false,
      // 用户角色
      user_category: 1,
      // 角色权限弹窗
      powerDialogShow: false
    }
  },
  created() {
    if (this.$route.path == '/register') {
      this.topLoginShow = false
    } else {
      this.initUser()
    }
  },
  computed: {
    showLogin() {
      //  计算属性
      return this.$store.state.showLogin //  Vuex 中定义的属性
    }
  },
  methods: {
    initUser() {
      // 获取用户信息
      let _this = this
      _this
        .$axios({
          method: 'get',
          url: '/service/user/userinfo'
        })
        .then(function (res) {
          console.log(res.data)
          if (res.data.code == 200 && res.data.data.phone) {
            _this.userMessage = res.data.head
            _this.userRole = res.data.data.role
            _this.user_category = res.data.data.user_category
            _this.topLoginShow = true
            _this.$store.commit('upLoginShow', _this.topLoginShow)
            _this.$store.commit('upUserRole', res.data.data.user_category)
            _this.$store.commit('upUserHead', res.data.head)
            _this.$emit('getInfo')
          } else if (res.data.code == 200 && res.data.data.role == 'admin') {
            _this.userMessage = res.data.head
            _this.userRole = res.data.data.role
            _this.topLoginShow = true
            _this.$store.commit('upLoginShow', _this.topLoginShow)
            _this.$store.commit('upUserRole', res.data.data.user_category)
            _this.$store.commit('upUserHead', res.data.head)
            _this.$emit('getInfo')
          }
          let loginkeyarr = {
            loginBloon: !!res.data.data.institution,
            frimName: res.data.data.institution,
            id: res.data.data._id
          }
          console.log('---------')
          _this.$store.commit('logoChange', loginkeyarr)
          console.log(_this.$store.state.logininfo)
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response, 'e.response')
          _this.$store.commit('upLoginShow', false)
        })
      // 获取消息通知的数量
      let qsData = this.$qs.stringify({
        page: 1,
        pageSize: 10
      })
      _this
        .$axios({
          method: 'post',
          url: '/message/list',
          data: qsData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            let { unreadCount } = res.data
            this.totalCount = unreadCount
            _this.$store.commit('upUnRead', unreadCount)
          } else {
            this.totalCount = 0
            _this.$store.commit('upUnRead', 0)
          }
        })
        .catch((err) => {
          console.log(err)
          _this.$store.commit('upUnRead', 0)
        })
    },
    emptyReset() {
      // 清空重置
      let _this = this
      // 密码登录-------------------------------
      _this.loginPwdPhone = '' // 密码登录-手机号
      _this.loginPassword = '' // 密码登录-密码
      _this.loginGraphCode = '' // 密码登录-图形验证码
      // 验证码登录-------------------------------
      _this.loginCodePhone = '' // 验证码登录-手机号
      _this.loginVeriCode = '' // 验证码登录-验证码
      // 登录提示-------------------------------
      _this.phoneHint = '' // 手机号-提示
      _this.pwdHint = '' // 密码-提示
      _this.imgCodeHint = '' // 图形验证码-提示
      _this.veriCodeHint = '' // 短信验证码登录-短信验证码-提示
      _this.pwdFindHint = '8-16字符，至少同时包含字母和数字'
      // 找回密码-------------------------------
      _this.findPhone = '' // 找回密码-手机号
      _this.findVeriCode = '' // 找回密码-短信验证码
      _this.findPwd = '' // 找回密码-密码
      _this.findRepeatPwd = '' // 找回密码-确认密码
      _this.findVeriHint = '' // 找回密码-短信验证码-提示
      _this.pwdRepeatHint = '' // 确认密码-提示
    },
    loginHandleClick(e) {
      // 右上角登录-登录框显示
      let _this = this
      let logType = e.target.dataset.logtype // 判断点击的是哪个--立即登录/企业登录/管理员登录
      _this.codeImgChange() // 获取图形验证码-图片
      _this.clickWay = logType == '管理员入口' // true/false 点击的是-立即登录/企业登录/管理员登录
      _this.loginVisibleShow = true
      _this.loginPopupShow = true
      _this.findPwdPopupShow = false
      _this.loginType = '0'
      _this.emptyReset()
    },
    getActiveIdx(val) {
      // 获取点击的tabs-判断登录方式(密码/验证码)
      let _this = this
      // _this.loginType = val.index
      console.log('登录方式-' + _this.loginType)
      _this.emptyReset()
    },
    phoneChangeBlur(phoneVal) {
      // 正则验证手机号
      let _this = this
      _this.phoneHint = phoneVal == '' ? '请输入手机号' : ''
      // let regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      // if (phoneVal == '') { // 密码登录-验证手机号
      //   _this.phoneHint = '请输入手机号'
      // } else if (regPhone.test(phoneVal)) {
      //   _this.phoneHint = ''
      // } else {
      //   _this.phoneHint = '手机号长度11位,以13/14/15/16/17/18/19开头'
      // }
    },
    pwdChangeBlur(pwdVal) {
      // 正则验证密码
      let _this = this
      let regPwd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
      if (pwdVal == '') {
        _this.pwdFindHint = '8-16字符，至少同时包含字母和数字'
      } else if (regPwd.test(pwdVal)) {
        _this.pwdFindHint = ''
      } else {
        _this.pwdFindHint = '密码必须包含数字、字母且长度为8-20位' // 密码格式不符合要求！
      }
    },
    // 修改密码-旧密码验证
    upOldPassChangeBlur(oldPwdVal) {
      // 正则验证密码
      let _this = this
      if (oldPwdVal == '') {
        _this.oldPwdFindHint = '旧密码不能为空'
      } else {
        _this.oldPwdFindHint = ''
      }
    },
    pwdRepeatChangeBlur() {
      // 确认密码-验证
      let _this = this
      if (_this.findRepeatPwd == '') {
        _this.pwdRepeatHint = '请输入确认密码'
      } else if (_this.findRepeatPwd == _this.findPwd) {
        _this.pwdRepeatHint = ''
      } else {
        _this.pwdRepeatHint = '两次密码不一致'
      }
    },
    // 修改密码-验证
    upPwdRepeatChangeBlur() {
      let _this = this
      if (_this.upQpass == '') {
        _this.pwdRepeatHint = '请输入确认密码'
      } else if (_this.upQpass == _this.upNewPass) {
        _this.pwdRepeatHint = ''
      } else {
        _this.pwdRepeatHint = '两次密码不一致'
      }
    },
    // phonePwdLoginChangeBlur() { // 密码登录-验证手机号
    //   this.phoneChangeBlur(this.loginPwdPhone)
    // },
    pwdPasswordLoginChangeBlur() {
      // 密码登录-验证密码-判断是否填写
      let _this = this
      _this.pwdHint = _this.loginPassword == '' ? '请输入密码' : ''
    },
    imgCodeChangeBlur() {
      // 密码登录-图形验证码-判断是否填写
      let _this = this
      _this.imgCodeHint = _this.loginGraphCode == '' ? '请输入验证码' : ''
    },
    // phoneCodeLoginChangeBlur() { // 短信验证码登录-验证手机号
    //   this.phoneChangeBlur(this.loginCodePhone)
    // },
    veriCodeChangeBlur() {
      // 短信验证码登录-短信验证码-判断是否填写
      let _this = this
      _this.veriCodeHint = _this.loginVeriCode == '' ? '请输入验证码' : ''
    },
    // phoneFindChangeBlur() { // 找回密码-验证手机号
    //   this.phoneChangeBlur(this.findPhone)
    // },
    // pwdFindChangeBlur() { // 找回密码-验证密码
    //   this.pwdChangeBlur(this.findPwd)
    // },
    findVeriChangeBlur() {
      // 短信验证码-找回密码-判断是否填写
      let _this = this
      _this.findVeriHint = _this.findVeriCode == '' ? '请输入验证码' : ''
    },
    upFindVeriChangeBlur() {
      // 短信验证码-修改密码-判断是否填写
      let _this = this
      _this.findVeriHint = _this.upCode == '' ? '请输入验证码' : ''
    },
    codeImgChange() {
      // 获取图形验证码
      // 图形验证码-密码登录
      this.imgCodeUrl = '/code/login?' + Math.random()
    },

    // 获取验证码
    getLoginCodeClick() {
      // 验证码登录-获取验证码接口-倒计时120s
      this.$refs.codeInp.focus()
      let _this = this
      const TIME_COUNT = 120
      console.log(_this.phoneTrue + '===========================')
      let qsData = _this.$qs.stringify({
        mobile: _this.loginCodePhone
      })
      _this
        .$axios({
          method: 'post',
          url: '/an/u/send/code/login',
          data: qsData,
          // baseUrl: _this.urlCommon,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (res) {
          console.log(res)
          // console.log(res.data.code == 200)
          if (res.data.result_code == 200) {
            _this.phoneHint = ''
            _this.veriCodeHint = ''
            if (!_this.setTimer) {
              // && !!_this.phoneTrue
              _this.loginCountDown = TIME_COUNT
              _this.countDownShow = false
              _this.setTimer = setInterval(() => {
                if (_this.loginCountDown > 0 && _this.loginCountDown <= TIME_COUNT) {
                  _this.loginCountDown--
                } else {
                  _this.phoneHint = ''
                  _this.countDownShow = true
                  clearInterval(_this.setTimer)
                  _this.setTimer = null
                }
              }, 1000)
            }
          } else {
            if (res.data.message.indexOf('手机') >= 0) {
              _this.phoneHint = res.data.message
            } else {
              _this.veriCodeHint = res.data.message
            }
          }
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response)
        })
    },
    getFindCodeClick() {
      // 忘记-找回密码-获取短信验证码接口-倒计时120s
      let _this = this
      const TIME_COUNT_FIND = 120
      // console.log(_this.phoneTrue + '===========================')
      let qsData = _this.$qs.stringify({
        mobile: _this.findPhone
      })
      _this
        .$axios({
          method: 'post',
          url: '/an/u/send/code/forget',
          data: qsData,
          // baseUrl: _this.urlCommon,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (res) {
          console.log(res)
          // console.log(res.data.code == 200)
          if (res.data.result_code == 200) {
            _this.phoneHint = ''
            _this.findVeriHint = ''
            if (!_this.setFindTimer) {
              // && !!_this.phoneTrue
              _this.findCountDown = TIME_COUNT_FIND
              _this.countDownFindShow = false
              _this.setFindTimer = setInterval(() => {
                if (_this.findCountDown > 0 && _this.findCountDown <= TIME_COUNT_FIND) {
                  _this.findCountDown--
                } else {
                  _this.phoneHint = ''
                  _this.countDownFindShow = true
                  clearInterval(_this.setFindTimer)
                  _this.setFindTimer = null
                }
              }, 1000)
            }
          } else {
            if (res.data.message.indexOf('手机') >= 0) {
              _this.phoneHint = res.data.message
            } else {
              _this.veriCodeHint = res.data.message
            }
          }
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response)
        })
    },
    loginSubmit() {
      // 点击登录-操作-登录接口
      let _this = this
      console.log('登录')
      let qsData
      if (_this.loginType == '0') {
        // 密码登录
        qsData = _this.$qs.stringify({
          mobile: _this.loginPwdPhone,
          password: _this.loginPassword,
          imgcode: _this.loginGraphCode
        })
        _this.phoneChangeBlur(this.loginPwdPhone)
        _this.pwdPasswordLoginChangeBlur()
        _this.imgCodeChangeBlur()
        if (_this.phoneHint != '' || _this.pwdHint != '') {
          // || _this.imgCodeHint != ''
          return
        }
      } else {
        // 验证码登录
        qsData = _this.$qs.stringify({
          mobile: _this.loginCodePhone,
          mcode: _this.loginVeriCode
        })
        _this.phoneChangeBlur(this.loginCodePhone)
        _this.veriCodeChangeBlur()
        if (_this.phoneHint != '' || _this.veriCodeHint != '') {
          return
        }
      }
      console.log('qsData=' + qsData)
      // 登录接口
      _this
        .$axios({
          method: 'post',
          url: '/login',
          data: qsData,
          // baseUrl: _this.urlCommon,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (res) {
          console.log(res.data)
          console.log(res.data.result_code)
          if (res.data.status == 200) {
            // 登录成功
            _this.phoneHint = ''
            _this.pwdHint = ''
            _this.imgCodeHint = ''
            _this.veriCodeHint = ''
            _this.$message({
              message: '登录成功',
              type: 'success'
            })
            _this.initUser()
            _this.loginVisibleShow = false
            _this.topLoginShow = true
            if (_this.$route.path == '/register') {
              _this.$router.push('/')
            }
            // if (res.data.url) {
            //   let setTimeObj = setTimeout(function() {
            //     window.open(res.data.url, '_blank')
            //   }, 1000)
            //   clearTimeout(setTimeObj)
            //   setTimeObj = null
            // }
            // _this.$router.push( // 携带参数-跳转页面
            //   {
            //     path: '/akeyreport/reportcompany',
            //     query: {
            //       queryType: queryType
            //     }
            //   }
            // )
            // let { href } = this.$router.resolve({
            //   path: '/patent/list',
            //   query: { patentQuery: patentQuery }
            // })
            // window.open(href, '_blank') // 跳转新页面打开-实现方式
          } else {
            if (_this.loginType == '0') {
              // 密码登录
              // _this.imgCodeHint = res.data.msg
              if (res.data.msg.indexOf('手机') >= 0 || res.data.msg.indexOf('账号') >= 0) {
                _this.phoneHint = res.data.msg
              } else if (res.data.msg.indexOf('密码') >= 0) {
                _this.pwdHint = res.data.msg
              } else {
                _this.imgCodeHint = res.data.msg
              }
            } else {
              // _this.veriCodeHint = res.data.msg
              if (res.data.msg.indexOf('手机') >= 0) {
                _this.phoneHint = res.data.msg
              } else {
                _this.veriCodeHint = res.data.msg
              }
            }
          }
          _this.codeImgChange() // 获取图形验证码-图片
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response)
        })
    },
    forgetPwdHandleClick() {
      // 点击忘记密码-找回密码框显示
      let _this = this
      // _this.loginVisibleShow = false
      _this.loginPopupShow = false
      _this.findPwdPopupShow = true
    },
    ForgetSubmit() {
      // 忘记密码并登录-找回密码接口
      let _this = this
      console.log('登录')
      let qsData = _this.$qs.stringify({
        mobile: _this.findPhone,
        code: _this.findVeriCode,
        pwd: _this.findPwd,
        repeat_pwd: _this.findRepeatPwd
      })
      _this.phoneChangeBlur(_this.findPhone)
      _this.findVeriChangeBlur()
      _this.pwdChangeBlur(_this.findPwd)
      _this.pwdRepeatChangeBlur()
      // phoneHint findVeriHint pwdFindHint pwdRepeatHint
      if (_this.phoneHint != '' || _this.findVeriHint != '' || _this.pwdFindHint != '' || _this.pwdRepeatHint != '') {
        return
      }
      console.log('qsData=' + qsData)
      // 忘记-找回密码接口
      _this
        .$axios({
          method: 'post',
          url: '/an/u/forget',
          data: qsData,
          // baseUrl: _this.urlCommon,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (res) {
          console.log(res.data)
          console.log(res.data.result_code)
          if (res.data.result_code == 200) {
            // 登录成功
            _this.phoneHint = ''
            _this.findVeriHint = ''
            _this.pwdFindHint = '8-16字符，至少同时包含字母和数字'
            _this.pwdRepeatHint = ''
            _this.findPwdPopupShow = false
            _this.loginVisibleShow = false
            _this.$message({
              message: '找回密码成功',
              type: 'success'
            })
            let loginData
            loginData = _this.$qs.stringify({
              mobile: _this.findPhone,
              password: _this.findPwd
              // code: _this.loginGraphCode
            })
            _this
              .$axios({
                method: 'post',
                url: '/login',
                data: loginData,
                // baseUrl: _this.urlCommon,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                }
              })
              .then(function (res) {
                console.log(res)
                _this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                _this.topLoginShow = true
              })
          } else {
            // _this.pwdRepeatHint = res.data.message
            if (res.data.message.indexOf('手机') >= 0) {
              _this.phoneHint = res.data.message
            } else if (res.data.message.indexOf('验证码') >= 0) {
              _this.findVeriHint = res.data.message
            } else if (res.data.message.indexOf('密码') >= 0) {
              _this.pwdFindHint = res.data.message
            } else {
              _this.pwdRepeatHint = res.data.message
            }
          }
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response)
        })
    },
    upCodeClick() {
      // 修改密码-获取短信验证码接口-倒计时120s
      let _this = this
      const TIME_COUNT_FIND = 120
      // console.log(_this.phoneTrue + '===========================')
      let qsData = _this.$qs.stringify({
        mobile: _this.upPhone
      })
      _this
        .$axios({
          method: 'post',
          url: '/an/u/send/code/forget',
          data: qsData,
          // baseUrl: _this.urlCommon,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (res) {
          console.log(res)
          // console.log(res.data.code == 200)
          if (res.data.result_code == 200) {
            _this.phoneHint = ''
            _this.findVeriHint = ''
            if (!_this.setFindTimer) {
              // && !!_this.phoneTrue
              _this.findCountDown = TIME_COUNT_FIND
              _this.countDownFindShow = false
              _this.setFindTimer = setInterval(() => {
                if (_this.findCountDown > 0 && _this.findCountDown <= TIME_COUNT_FIND) {
                  _this.findCountDown--
                } else {
                  _this.phoneHint = ''
                  _this.countDownFindShow = true
                  clearInterval(_this.setFindTimer)
                  _this.setFindTimer = null
                }
              }, 1000)
            }
          } else {
            if (res.data.message.indexOf('手机') >= 0) {
              _this.phoneHint = res.data.message
            } else {
              _this.veriCodeHint = res.data.message
            }
          }
        })
        .catch(function (e) {
          console.log('error------------------------------error')
          console.log(e.response)
        })
    },
    // 修改密码-提交
    upForgetSubmit() {
      let _this = this
      console.log('修改密码')
      _this.phoneChangeBlur(_this.upPhone)
      if (_this.upPassCodeShow) {
        _this.upFindVeriChangeBlur()
      } else {
        _this.upOldPassChangeBlur(_this.upOldPass)
      }
      _this.pwdChangeBlur(_this.upNewPass)
      _this.upPwdRepeatChangeBlur()
      // 判断是否显示验证码，如果没有验证码，则判断是否输入旧密码
      if (_this.upPassCodeShow) {
        if (_this.phoneHint != '' || _this.findVeriHint != '' || _this.pwdFindHint != '' || _this.pwdRepeatHint != '') {
          return
        }
      } else {
        if (
          _this.phoneHint != '' ||
          _this.oldPwdFindHint != '' ||
          _this.pwdFindHint != '' ||
          _this.pwdRepeatHint != ''
        ) {
          return
        }
      }

      let qsData = _this.$qs.stringify({
        mobile: _this.upPhone,
        // code: _this.upCode,
        oldpassword: _this.upOldPass,
        newPassword: _this.upNewPass,
        newPasswordTwo: _this.upQpass
      })
      let qsData2 = _this.$qs.stringify({
        mobile: _this.upPhone,
        code: _this.upCode,
        pwd: _this.upNewPass,
        repeat_pwd: _this.upQpass
      })
      if (_this.upCode) {
        _this
          .$axios({
            method: 'post',
            url: '/an/u/forget',
            data: qsData2,
            // baseUrl: _this.urlCommon,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then((res) => {
            if (res.data.result_code == 200) {
              _this.$message({
                message: '密码修改成功',
                type: 'success',
                duration: 3000
              })
              _this.upPwdPopupShow = false
            } else {
              // 验证码过期
              if (res.data.result_code == 40016) {
                _this.findVeriHint = res.data.message
              }
            }
          })
      } else {
        _this
          .$axios({
            method: 'post',
            url: '/service/user/uppassword',
            data: qsData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then((res) => {
            console.log(res)
            if (res.data.code == 200) {
              _this.$message({
                message: res.data.msg,
                type: 'success',
                duration: 3000
              })
              _this.upPwdPopupShow = false
            } else {
              // 旧密码和新密码相同
              if (res.data.result_code == 40016) {
                _this.pwdFindHint = res.data.msg
              } else if (res.data.result_code == 11006) {
                _this.oldPwdFindHint = res.data.msg
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 进入消息通知页面
    goNews() {
      if (this.$route.path == '/enterprisemessage' || this.$route.path == '/adminmessage') {
        return false
      }
      let paths = ''
      if (this.userRole == 'user') {
        paths = '/enterprisemessage'
      } else {
        paths = '/adminmessage'
      }
      let { href } = this.$router.resolve({
        path: paths
      })
      window.open(href, '_blank') // 跳转新页面打开-实现方式
    },
    logoutHandleClick() {
      // 退出登录
      window.location.href = this.logoutHref
    },
    handleUserCommand(command) {
      // 右上角下拉框指令
      let _this = this
      console.log(command)
      if (command == 'a') {
        this.$router.push('/user/info')
      } else if (command == 'b') {
        this.$router.push('/user/integral')
      } else if (command == 'c') {
        // 去往我的服务页面
        // 如果用户角色为本地用户或者管理员并且绑定企业不为空，则可以跳转进入对应页面
        console.log(this.user_category)
        if ((this.user_category == 2 || this.user_category == 3) && this.institution != '') {
          this.$router.push('/user/services')
        } else {
          // 否则显示“权限不足”弹框
          this.powerDialogShow = true
        }
      } else if (command == 'd') {
        this.upPwdPopupShow = true
      } else if (command == 'e') {
        _this.popLoginShow = true
      }
      // if (command == 'exitLogin') {
      //   // 退出登录
      //   _this.topLoginShow = false
      //   _this.popLoginShow = true
      // }
    },
    // 修改密码，点击忘记旧密码
    upShowCode() {
      this.upPassCodeShow = true
      this.upOldPassShow = false
    },
    // 退出登录
    popLogin() {
      this.popLoginShow = false
      window.location = '/logout'
    }
  },
  watch: {
    showLogin() {
      this.loginHandleClick({
        target: {
          dataset: {
            logtype: '立即登录'
          }
        }
      }) //   需要调用的方法
    },
    // 修改密码
    upPwdPopupShow() {
      this.upOldPassShow = true
      this.upPassCodeShow = false
      // 修改密码-手机号
      this.upPhone = ''
      // 修改密码-旧密码
      this.upOldPass = ''
      // 修改密码-验证码
      this.upCode = ''
      // 修改密码-新密码
      this.upNewPass = ''
      // 修改密码-确认新密码
      this.upQpass = ''
      this.oldPwdFindHint = ''
      this.pwdFindHint = '8-16字符，至少同时包含字母和数字'
      this.pwdRepeatHint = ''
      this.phoneHint = ''
    }
  },
  beforeDestory() {
    clearTimeout(this.setTimer)
    this.setTimer = null
    clearTimeout(this.setFindTimer)
    this.setFindTimer = null
  }
}
</script>
<style scoped>
/* 弹窗 */
:deep(.el-dialog__header) {
  display: none !important;
}

:deep(.el-dialog__body) {
  padding: 40px;
  text-align: left;
}

.viewpop-viewtitle {
  display: block;
  text-align: center;
  line-height: 22px;
  color: #d42a2a;
  font-weight: 700;
  font-size: 16px;
}

.dialog-info {
  margin: 20px 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.dialog-info p {
  line-height: 20px;
  margin-bottom: 5px;
}

.viewpop-viewbtn {
  margin-top: 15px;
  display: -webkit-flex;
  /* Safari */
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  /* 右对齐 */
  align-items: center;
}

.viewbtn-integral {
  margin-right: 20px;
  display: flex;
  align-items: center;
  color: #d42a2a;
  font-size: 12px;
}

.viewbtn-integral > p {
  font-weight: bold;
  margin-right: 20px;
  text-align: left;
}

.viewbtn-btnstyle {
  padding: 0;
  width: 70px;
  height: 21px;
  line-height: 21px;
  background: #dddddd;
  border: 1px solid #dddddd;
  border-radius: 2px;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 12px;
}

.advbtn-replybtn:hover {
  background: #dddddd;
  border: 1px solid #dddddd;
  color: #ffffff;
}

.viewbtn-replybtn-active {
  background: #d42a2a;
  border: 1px solid #d42a2a;
  margin-right: 15px;
}

.viewbtn-delbtn {
  background: #ffffff;
  border: 1px solid #797979;
  color: #797979;
}
</style>

<style scoped>
.common-topbox {
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  min-width: 1400px;
  height: 36px;
  overflow: hidden;
  background: #000;
  box-sizing: border-box;
}

.topbox-htoptle {
  display: block;
  float: left;
  padding-left: 1px;
  line-height: 36px;
  color: #fff;
}

/* top-右侧-登录之后的样式 */
.topbox-htoploginuser {
  float: right;
  width: 500px;
  line-height: 36px;
  overflow: hidden;
}

.htopmenu-msgnum {
  position: relative;
  display: block;
  float: right;
  margin-right: 42px;
  line-height: 36px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}

.msgnum-style {
  position: absolute;
  top: 0;
  right: -22px;
  width: 20px;
  height: 20px;
  line-height: 18px;
  background: #d42a2a;
  border-radius: 50%;
  color: #ffffff;
  font-size: 12px;
}

.htopmenu-userinfo {
  display: block;
  float: right;
  max-width: 400px;
  box-sizing: border-box;
}

.userinfo-userres {
  position: relative;
  display: block;
  margin-right: 20px;
  padding-right: 15px;
  max-width: 400px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}

.icon-sanjiaodown {
  position: absolute;
  right: 0px;
  font-size: 12px;
}

/* 以上为登录之后的样式 */
/* top-右侧-未登录的样式 */
.topbox-htopmenu {
  float: right;
  width: 300px;
  line-height: 36px;
  overflow: hidden;
}

.htopmenu-htopli {
  position: relative;
  float: left;
  margin-left: 20px;
}

.htopmenu-htopli:nth-child(1) {
  margin-left: 0;
  padding-right: 10px;
}

.htopmenu-htopli:nth-child(2) {
  margin-left: 10px;
}

.htopmenu-htopli .htopli-htopi {
  display: block;
  position: absolute;
  top: 12px;
  right: 0;
  width: 1px;
  height: 12px;
  background: #fff;
}

.htopmenu-htopli .htopli-htopa {
  display: block;
  height: 36px;
  line-height: 36px;
  color: #fff;
  cursor: pointer;
}

.htopmenu-htopli .htopli-htoplogin {
  color: #ff0000;
}

/* 登录弹框 */
:deep(.popup-loginpop) {
  width: 340px !important;
  box-sizing: border-box !important;
}

:deep(.popup-loginpop .el-dialog__header) {
  display: none;
}

:deep(.popup-loginpop .el-dialog__body) {
  padding: 30px 40px;
}

/* tab切换  密码登录/验证码登录 */
.loginpop-logintabs {
  margin: 0 auto;
  width: 260px;
}

.loginpop-logintabs :deep(.el-tabs__content) {
  overflow: initial;
}

.loginpop-logintabs :deep(.el-tabs__nav-scroll) {
  height: 40px;
}

.loginpop-logintabs :deep(.el-tabs__nav) {
  border: none;
}

.loginpop-logintabs :deep(.el-tabs__item) {
  display: block;
  float: left;
  width: 130px;
  height: 40px;
  line-height: 38px;
  background: #ffffff;
  border: none;
  text-align: center;
  color: #777777;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
}

.loginpop-logintabs .el-tabs__item:first-child {
  margin-right: 20px;
}

.loginpop-logintabs :deep(.el-tabs__item:hover) {
  color: #777777;
}

.loginpop-logintabs :deep(.el-tabs__item.is-active) {
  background: #ffffff;
  color: #d42a2a;
}

.loginpop-logintabs :deep(.el-tabs__item.is-active::after) {
  position: absolute;
  content: '';
  left: 50%;
  bottom: -5px;
  margin-left: -20px;
  width: 40px;
  height: 4px;
  background: #d42a2a;
}

/* 登录input样式 */
/* 密码登录 */
.login-box {
  margin-top: 30px;
  margin-bottom: 20px;
}

.login-logform {
  position: relative;
  padding-bottom: 20px;
}

.logform-loginput {
}

.logform-loginput :deep(.el-input__inner) {
  padding: 0 10px;
  width: 260px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #797979;
  border-radius: 0;
  box-sizing: border-box;
}

.logform-loghint {
  position: absolute;
  top: 32px;
  left: 0;
  width: 100%;
  height: 16px;
  text-align: left;
  color: #999999;
  font-size: 12px;
  z-index: 1;
}

.logform-logerror {
  color: #fd0000;
}

/* 图形验证码 */
.login-loggraphcode {
  margin-bottom: 22px;
  overflow: hidden;
}

.loggraphcode-graphname {
  display: block;
  float: left;
  line-height: 30px;
}

.loggraphcode-gracodebox {
  overflow: hidden;
}

.loggraphcode-graphinput {
  display: block;
  float: left;
  width: 150px;
}

.loggraphcode-graphinput :deep(.el-input__inner) {
  padding: 0 10px;
  width: 150px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #797979;
  border-radius: 0;
  box-sizing: border-box;
}

.loggraphcode-graphimg {
  display: block;
  float: right;
  width: 70px;
  height: 30px;
  border: 1px solid #797979;
  box-sizing: border-box;
}

.logform-gracodehint {
  top: 35px;
  width: 160px;
}

/* 忘记密码-按钮 */
.logform-logforgetbtn {
  position: absolute;
  top: 32px;
  /* 把图形验证码-注释掉之后的样式 */
  /* top: 35px; */
  right: 0;
  padding: 0;
  width: 100px;
  height: 16px;
  text-align: right;
  color: #999999;
  font-size: 12px;
  z-index: 1;
}

/* 验证码登录 */
.login-logverificate {
  margin-bottom: 22px;
}

.logverificate-loginput {
  padding-right: 0px;
}

.logform-logveribtn.el-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  width: 90px;
  height: 30px;
  line-height: 28px;
  color: #d42a2a;
}

.logform-logveribtn-active.is-disabled {
  background: none;
  border: none;
}

/* 点击登录按钮 */
.loginpop-loginbtn {
  margin: 0 auto 10px;
  padding: 0;
  width: 260px;
  height: 30px;
  line-height: 28px;
  background: #d42a2a;
  border: 1px solid #d42a2a;
  border-radius: 4px;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 14px;
}

/* 点击注册按钮 */
.loginpop-goregister {
  display: block;
  margin: 0 auto;
  padding: 0;
  width: 260px;
  height: 30px;
  line-height: 28px;
  background: #ffffff;
  border: 1px solid #d42a2a;
  border-radius: 4px;
  box-sizing: border-box;
  color: #d42a2a;
  font-size: 14px;
  text-align: center;
}

/* 忘记密码-找回密码-弹框 */
.popup-findpwdpop {
}

.findpwdpop-findtitle {
  text-align: center;
  color: #d42a2a;
  font-weight: 700;
  font-size: 20px;
}

/* 找回密码-获取短信验证码input */
.findpwd-fverificate {
  margin-bottom: 0;
}

.findpwd-repeatmb {
  margin-bottom: 22px;
}
</style>
